import axios from "axios";
import { SaleDetailResponse, SaleResponse } from "./dto/Sale";

/**
 * 売上情報一覧を取得する
 */
export const getSales = async (): Promise<SaleResponse[]> => {
  const res = await axios.get<SaleResponse[]>(`/api/users/sale/list`);
  return res.data;
};

/**
 * 売上明細一覧を取得する
 */
export const getSaleDetails = async (): Promise<SaleDetailResponse[]> => {
  const res = await axios.get(`/api/users/sale/detail/list`);
  return res.data;
};
